import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";

import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");
  const [start, setIndexStart] = useParameter<number>("@index_start");
  const [end, setIndexEnd] = useParameter<number>("@index_end");
  const [commodities] = useParameter<number[]>("@commodities");
  const [commoditiesDisplay] = useParameter<number[]>("@commodities_display");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@calendar": calendar,
      "@commodities": commodities,
      "@commodities_display": commoditiesDisplay,
      "@index_start": start,
      "@index_end": end,
    });
  }, [title, subtitle, start, end, calendar, commoditiesDisplay, commodities, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setIndexStart((parameters["@index_start"].value as string[]).map(Number)[0]);
      setIndexEnd((parameters["@index_end"].value as string[]).map(Number)[0]);
    },
    [setIndexEnd, setIndexStart]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
